import React from "react"
import { CompaniesController } from "./controller"
import { CompaniesView } from "./view"
export const Companies = (): JSX.Element => {
    return (
        <CompaniesController>
            <CompaniesView />
        </CompaniesController>
    )
}